import { z } from 'zod'
import { optionalText, requiredText } from '../../../lib/forms/rules'

/**
 * Davet türü ekle/düzenle form şeması (025): nameTr zorunlu; nameEn opsiyonel. Sıra (SORT_INDEX) formda
 * yok — sıralama tablodaki ↑/↓ oklarından yapılır (oluşturmada sona otomatik atanır).
 */
export const invitationTypeFormSchema = z.object({
  nameTr: requiredText(),
  nameEn: optionalText(),
})

export type InvitationTypeFormValues = z.infer<typeof invitationTypeFormSchema>
